window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('overlayscrollbars');
    require('../../vendor/almasaeed2010/adminlte/dist/js/adminlte');
    require('datatables.net');
    require('datatables.net-dt');
    require('datatables.net-buttons');
    require('datatables.net-buttons/js/buttons.colVis.js')();
    require('datatables.net-buttons/js/buttons.print.js')();
    require('datatables.net-buttons/js/buttons.flash.js')();
    require('datatables.net-buttons/js/buttons.html5.js')();
    require('datatables.net-fixedheader');
    require('datatables.net-select/js/dataTables.select.min');
    require('datatables.net-rowreorder/js/dataTables.rowReorder.min');
    require('select2');
    require('chart.js');
    window.Swal = require('sweetalert2');
    require('bootstrap-filestyle');
    require('hideshowpassword');
    require('suggestags');
    // var Inputmask = require('inputmask');
    // require('inputmask/dist/jquery.inputmask.min');
    window.moment = require('moment/moment');
    require('daterangepicker/daterangepicker');
    require('btecu-eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min')
    require('multiselect-two-sides/dist/js/multiselect.min');

    require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
